import { ReferralChannelsActionTypes, ReferralChannelsState } from './types';
import { Reducer } from 'redux';

const initialState: ReferralChannelsState = {
  loading: false,
  acLoading: false,
  error: '',
  activeChannel: undefined,
  draftChannel: undefined,
  gmlProjectionItems: undefined,
  pausedReferralsCount: 0
};

const reducer: Reducer<ReferralChannelsState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case ReferralChannelsActionTypes.FETCH_REFERRAL_CHANNELS_START: {
      return {
        ...state,
        loading: true
      };
    }
    case ReferralChannelsActionTypes.FETCH_REFERRAL_CHANNELS_SUCCESS: {
      const { activeChannel, draftChannel } = action.payload;
      return {
        ...state,
        loading: false,
        activeChannel,
        draftChannel
      };
    }
    case ReferralChannelsActionTypes.FETCH_REFERRAL_CHANNELS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case ReferralChannelsActionTypes.DRAFT_REFERRAL_CHANNELS_START: {
      const { draftChannel } = state;
      return {
        ...state,
        draftChannel: {
          ...draftChannel,
          submitting: true
        }
      };
    }
    case ReferralChannelsActionTypes.DRAFT_REFERRAL_CHANNELS_SUCCESS: {
      const draftChannel = {
        submitting: false,
        ...action.payload
      };
      return {
        ...state,
        loading: false,
        draftChannel
      };
    }
    case ReferralChannelsActionTypes.DRAFT_REFERRAL_CHANNELS_FAILURE: {
      return {
        ...state,
        draftChannel: {
          submitting: false
        },
        error: action.payload
      };
    }
    case ReferralChannelsActionTypes.UPDATE_REFERRAL_CHANNELS_START: {
      const draftChannel = action.payload.requestBody;
      const loading = draftChannel?.status === 'LIVE' && true;
      return {
        ...state,
        loading,
        draftChannel: {
          ...draftChannel,
          submitting: true
        }
      };
    }
    case ReferralChannelsActionTypes.UPDATE_REFERRAL_CHANNELS_SUCCESS: {
      const { activeChannel, draftChannel } = action.payload;
      return {
        ...state,
        loading: false,
        activeChannel,
        draftChannel
      };
    }
    case ReferralChannelsActionTypes.UPDATE_REFERRAL_CHANNELS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case ReferralChannelsActionTypes.FETCH_GML_PROJECTION_START: {
      return {
        ...state
      };
    }
    case ReferralChannelsActionTypes.FETCH_GML_PROJECTION_SUCCESS: {
      return {
        ...state,
        gmlLoading: false,
        gmlProjectionItems: action.payload
      };
    }
    case ReferralChannelsActionTypes.FETCH_GML_PROJECTION_FAILURE:
      return {
        ...state,
        gmlLoading: false,
        error: action.payload
      };
    case ReferralChannelsActionTypes.FETCH_ACTIVE_CHANNEL_START: {
      return {
        ...state,
        acLoading: true
      };
    }
    case ReferralChannelsActionTypes.FETCH_ACTIVE_CHANNEL_SUCCESS: {
      return {
        ...state,
        acLoading: false,
        pausedReferralsCount: action.payload.pausedReferralsCount
      };
    }
    case ReferralChannelsActionTypes.FETCH_ACTIVE_CHANNEL_FAILURE:
      return {
        ...state,
        acLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export { reducer as ReferralChannelsReducer };
